<template>

  <v-dialog
    v-model     = "isDialogOpen"
    width       = "400px"
  >
    <v-card>
      <v-card-title>{{ title }}</v-card-title>
      <v-card-text>

        <v-form
          v-model = "formIsValid"
          class   = "form"
        >
          <v-jsf
            v-model       = "model"
            :schema       = "schema"
            :options      = "options"
            @change       = "change"
          >
          </v-jsf>
          <template slot="imageProp">
          </template>
        </v-form>

      </v-card-text>
      <v-card-actions>
        <v-btn
          elevation = "0"
          @click    = "onRestore"
        >
          Restore default
        </v-btn>

        <v-spacer></v-spacer>

        <v-btn
          elevation = "0"
          color     = "error"
          @click    = "onReject"
        >
          Cancel
        </v-btn>

        <v-btn
          elevation = "0"
          color     = "primary"
          :disabled = "!formIsValid"
          @click    = "onAccept"
        >
          Save
        </v-btn>

      </v-card-actions>
    </v-card>
  </v-dialog>

</template>

<script>

export default {

  // #region Properties

  name: 'PluginSettingsDialog',
  data() {
    return {
      isDialogOpen: false,

      title:            undefined,
      model:            undefined,
      schema:           undefined,
      options:          undefined,
      restore:          undefined,
      getUpdatedSchema: undefined,

      formIsValid: false,

      resolve: undefined
    }
  },

  // #endregion Properties

  // #region Methods

  methods: {

    // #region Events
    async onRestore() {
      try {
        const newModel = await this.restore();
        this.model = newModel;
      } catch(e) {
        this.resolve(undefined);
      }
    },

    onReject() {
      this.isDialogOpen = false;
      this.resolve(undefined);
    },

    onAccept() {
      this.isDialogOpen = false;
      this.resolve(this.model);
    },

    async change(settingsModel) {
      if (!this.getUpdatedSchema)
        return;

      const newSchema = await this.getUpdatedSchema(settingsModel);

      if (newSchema) {
        this.schema = newSchema.settings.schema;
        this.options = newSchema.settings.options;
      }
    },

    // #endregion Events

    configure(
      title,
      model,
      schema,
      options,
      restore,
      getUpdatedSchema
    ) {
      this.title = title;
      this.model = model;
      this.schema = schema;
      this.options = options;
      this.restore = restore;
      this.getUpdatedSchema = getUpdatedSchema;

      this.isDialogOpen = true;

      return new Promise(resolve => {
        this.resolve = resolve;
      });
    }

  }

  // #endregion Methods

}

</script>
